module.exports = __webpack_public_path__ + "img/imagem-capa.d00a37b5.jpg";